import * as React from 'react';
import UsersComponent from '../Containers/Users/UsersComponent';
import SettingsComponent from '../Containers/Settings';
import CasinoReportComponent from '../Containers/Reports/CasinoReport';
import PlayersReportComponent from '../Containers/Reports/PlayersReport';
import GamesReportComponent from '../Containers/Reports/GamesReport';
import MonthlyBillingComponent from '../Containers/Reports/MonthlyBillingReport';
import ReportsComponent from '../Containers/Reports/ReportsComponent';
import SearchResultContainer from '../Containers/SearchResult';
import PlayerProfileComponent from '../Containers/PlayerProfile';
import PromotionPage from '../Containers/PlayerProfile/PromotionPage';
import { PageNotFoundComponent } from '../Containers/Errors/PageNotFoundComponent';
import DashboardMobileComponent from '../mobile/DashboardMobileComponent';
import BrokenRoundsPage from '../Containers/BrokenRoundsPage/BrokenRoundsPage';
import Operators from '../ConfigurationProvider/Lists/Operators';
import Games from '../ConfigurationProvider/Lists/Games';
import Currencies from '../ConfigurationProvider/Lists/Currencies';
import OperatorGameConfigurations from '../ConfigurationProvider/Lists/Operators/OperatorGameConfigurations/OperatorGameConfigurations';
import AddOperator from '../ConfigurationProvider/AddOperator';
import AddGame from '../ConfigurationProvider/AddGame';
import AddBrand from '../ConfigurationProvider/ManageBrands/AddBrand';
import EditBrand from '../ConfigurationProvider/ManageBrands/EditBrand';
import ManageGames from '../ConfigurationProvider/Lists/Operators/ManageGames/ManageGames';
import ManageCurrencies from '../ConfigurationProvider/Lists/Operators/ManageСurrencies/ManageCurrencies';
import EditDefaultConfig from '../ConfigurationProvider/Lists/Games/EditDefaultConfig/EditDefaultConfig';
import EditCurrencyConfiguration from '../ConfigurationProvider/Lists/Currencies/EditCurrencyConfiguration/EditCurrencyConfiguration';
import AddDefaultGameConfig from '../ConfigurationProvider/Lists/Currencies/AddDefaultGameConfig';
import OperatorPage from '../ConfigurationProvider/OperatorPage';
import ChecksumReportComponent from '../Containers/Reports/ChecksumReport';
import RoundInfoPage from '../Containers/RoundInfoPage/RoundInfoPage';
import UnfinishedRoundsPage from '../ConfigurationProvider/UnfinishedRounds/UnfinishedRoundsPage';
import ToolsMenu from '../ConfigurationProvider/Home/ToolsMenu';
import AwardedPromotions from '../BackOffice/Promotions/AwardedRounds/PromotionsReport';
import AwardedCampaignControl from '../BackOffice/Promotions/AwardedRounds/PromotionControlPage/CampaignControl';
import EditAwardedCampaign from '../BackOffice/Promotions/AwardedRounds/PromotionControlPage/EditAwardedCampaign';
import UnfinishedRoundJobs from '../ConfigurationProvider/Lists/UnfinishedRoundJobs';
import ManageGamesInAwardedCampaign from '../BackOffice/Promotions/AwardedRounds/PromotionControlPage/ManageGames';
import ManagePlayersInAwardedCampaign from '../BackOffice/Promotions/AwardedRounds/PromotionControlPage/ManagePlayers';
import OLDPerformanceReportComponent from '../Containers/OldReports/CasinoReport';
import OLDPlayersReportComponent from '../Containers/OldReports/PlayersReport';
import OLDGamesReportComponent from '../Containers/OldReports/GamesReport';
import NewAwardedPromotion from '../BackOffice/Promotions/AwardedRounds/NewAwardedPromotion';
import CloneAwardedPromotion from '../BackOffice/Promotions/AwardedRounds/CloneAwardedPromotion';
import FreeRoundsPromotions from '../BackOffice/Promotions/FreeRounds/PromotionsReport';
import NewFreeRoundsPromotion from '../BackOffice/Promotions/FreeRounds/NewFreeRoundsPromotion';
import CloneFreeRoundsPromotion from '../BackOffice/Promotions/FreeRounds/CloneFreeRoundsPromotion';
import FreeRoundsPromotionControl from '../BackOffice/Promotions/FreeRounds/PromotionControlPage/CampaignControl';
import EditFreeRoundsPromotion from '../BackOffice/Promotions/FreeRounds/PromotionControlPage/EditFreeRoundsCampaign';
import OLDPlayerProfileComponent from '../Containers/OldReports/PlayerProfile';
import ManagePlayersInFreeRoundsCampaign from '../BackOffice/Promotions/FreeRounds/PromotionControlPage/ManagePlayers';
import ManageGamesInFreeRoundsCampaign from '../BackOffice/Promotions/FreeRounds/PromotionControlPage/ManageGames';
import ApiAccessList from '../ConfigurationProvider/ApiAccess/ApiAccessList';
import ApiAccessDetails from '../ConfigurationProvider/ApiAccess/ApiAccessDetails';

export const routes = [
    {
        path: `/casino/reports/*`,
        belonging: ['backOffice'],
        innerComponent: <ReportsComponent />,
    },
    {
        path: `/casino/dashboard`,
        belonging: ['backOffice'],
        innerComponent: <DashboardMobileComponent />,
    },
    {
        path: `/casino/users`,
        belonging: ['backOffice'],
        innerComponent: <UsersComponent />,
    },
    {
        path: `/casino/settings`,
        belonging: ['backOffice'],
        innerComponent: <SettingsComponent />,
    },
    {
        path: `/casino/reports/casino-performance`,
        belonging: ['backOffice'],
        innerComponent: <CasinoReportComponent />,
    },
    {
        path: `/casino/reports/players-performance`,
        belonging: ['backOffice'],
        innerComponent: <PlayersReportComponent />,
    },
    {
        path: `/casino/reports/games-performance`,
        belonging: ['backOffice'],
        innerComponent: <GamesReportComponent />,
    },
    {
        path: `/casino/reports/legacy/casino-performance`,
        belonging: ['backOffice'],
        innerComponent: <OLDPerformanceReportComponent />,
    },
    {
        path: `/casino/reports/legacy/players-performance`,
        belonging: ['backOffice'],
        innerComponent: <OLDPlayersReportComponent />,
    },
    {
        path: `/casino/reports/legacy/games-performance`,
        belonging: ['backOffice'],
        innerComponent: <OLDGamesReportComponent />,
    },
    {
        path: `/casino/reports/critical-checksum`,
        belonging: ['backOffice', 'configProvider'],
        innerComponent: <ChecksumReportComponent />,
    },
    {
        path: `/casino/reports/monthly-billing-report`,
        belonging: ['backOffice'],
        innerComponent: <MonthlyBillingComponent />,
    },
    {
        path: `/casino/players/legacy/:playerId/:login`,
        belonging: ['backOffice'],
        innerComponent: <OLDPlayerProfileComponent />,
    },
    {
        path: `/casino/players/:playerId/:login`,
        belonging: ['backOffice'],
        innerComponent: <PlayerProfileComponent />,
    },
    {
        path: `/casino/promotion/:queryParams`,
        belonging: ['backOffice'],
        innerComponent: <PromotionPage />,
    },
    // Free Rounds Promotions
    {
        path: `/casino/free-rounds-promotions`,
        belonging: ['backOffice'],
        innerComponent: <FreeRoundsPromotions />,
    },
    {
        path: `/casino/free-rounds-promotion/new`,
        belonging: ['backOffice'],
        innerComponent: <NewFreeRoundsPromotion />,
    },
    {
        path: `/casino/free-rounds-promotion/clone/:campaignId`,
        belonging: ['backOffice'],
        innerComponent: <CloneFreeRoundsPromotion />,
    },
    {
        path: `/casino/free-rounds-promotion/:campaignId`,
        belonging: ['backOffice'],
        innerComponent: <FreeRoundsPromotionControl />,
    },
    {
        path: `/casino/free-rounds-promotion/:campaignId/:edit?`,
        belonging: ['backOffice'],
        innerComponent: <EditFreeRoundsPromotion />,
    },
    {
        path: `/casino/free-rounds-promotion/:campaignId/manage-games`,
        belonging: ['backOffice'],
        innerComponent: <ManageGamesInFreeRoundsCampaign />,
    },
    {
        path: `/casino/free-rounds-promotion/:campaignId/manage-players`,
        belonging: ['backOffice'],
        innerComponent: <ManagePlayersInFreeRoundsCampaign />,
    },
    {
        path: `/casino/awarded-promotions`,
        belonging: ['backOffice'],
        innerComponent: <AwardedPromotions />,
    },
    {
        path: `/casino/awarded-promotion/new`,
        belonging: ['backOffice'],
        innerComponent: <NewAwardedPromotion />,
    },
    {
        path: `/casino/awarded-promotion/clone/:campaignId`,
        belonging: ['backOffice'],
        innerComponent: <CloneAwardedPromotion />,
    },
    {
        path: `/casino/awarded-promotion/:campaignId`,
        belonging: ['backOffice'],
        innerComponent: <AwardedCampaignControl />,
    },
    {
        path: `/casino/awarded-promotion/:campaignId/:edit?`,
        belonging: ['backOffice'],
        innerComponent: <EditAwardedCampaign />,
    },
    {
        path: `/casino/awarded-promotion/:campaignId/edit`,
        belonging: ['backOffice'],
        innerComponent: <EditAwardedCampaign />,
    },
    {
        path: `/casino/awarded-promotion/:campaignId/manage-games`,
        belonging: ['backOffice'],
        innerComponent: <ManageGamesInAwardedCampaign />,
    },
    {
        path: `/casino/awarded-promotion/:campaignId/manage-players`,
        belonging: ['backOffice'],
        innerComponent: <ManagePlayersInAwardedCampaign />,
    },
    {
        path: `/casino/search-result/:player`,
        belonging: ['backOffice'],
        innerComponent: <SearchResultContainer />,
    },
    {
        path: `/config-provider/tools/`,
        belonging: ['configProvider'],
        innerComponent: <ToolsMenu />,
    },
    {
        path: `/config-provider/api-access`,
        belonging: ['configProvider'],
        innerComponent: <ApiAccessList />,
    },
    {
        path: `/config-provider/api-access/:operatorId`,
        belonging: ['configProvider'],
        innerComponent: <ApiAccessDetails />,
    },
    {
        path: `/config-provider/operators/`,
        belonging: ['configProvider'],
        innerComponent: <Operators />,
    },
    {
        path: `/config-provider/operators/add-operator`,
        belonging: ['configProvider'],
        innerComponent: <AddOperator />,
    },
    {
        path: `/config-provider/operator/:operatorId`,
        belonging: ['configProvider'],
        innerComponent: <OperatorPage />,
    },
    {
        path: `/config-provider/operators/:operatorId/add-brand`,
        belonging: ['configProvider'],
        innerComponent: <AddBrand />,
    },
    {
        path: `/config-provider/operators/:operatorId/edit-brand`,
        belonging: ['configProvider'],
        innerComponent: <EditBrand />,
    },
    {
        path: `/config-provider/games`,
        belonging: ['configProvider'],
        innerComponent: <Games />,
    },
    {
        path: `/config-provider/round-info`,
        belonging: ['configProvider'],
        innerComponent: <RoundInfoPage />,
    },
    {
        path: `/config-provider/games/:gameId/game-configuration`,
        belonging: ['configProvider'],
        innerComponent: <EditDefaultConfig />,
    },
    {
        path: `/config-provider/currencies/:currencyId/currency-configuration`,
        belonging: ['configProvider'],
        innerComponent: <EditCurrencyConfiguration />,
    },
    {
        path: `/config-provider/operators/:operatorId/game-configurations`,
        belonging: ['configProvider'],
        innerComponent: <OperatorGameConfigurations />,
    },
    {
        path: `/config-provider/operators/:operatorId/manage-games`,
        belonging: ['configProvider'],
        innerComponent: <ManageGames />,
    },
    {
        path: `/config-provider/operators/:operatorId/manage-currencies`,
        belonging: ['configProvider'],
        innerComponent: <ManageCurrencies />,
    },
    {
        path: `/config-provider/games/add-game`,
        belonging: ['configProvider'],
        innerComponent: <AddGame />,
    },
    {
        path: `/config-provider/currencies`,
        belonging: ['configProvider'],
        innerComponent: <Currencies />,
    },
    {
        path: `/config-provider/currencies/add-default-config`,
        belonging: ['configProvider'],
        innerComponent: <AddDefaultGameConfig />,
    },
    {
        path: `/config-provider/broken-rounds/*`,
        belonging: ['configProvider'],
        innerComponent: <BrokenRoundsPage />,
    },
    {
        path: `/config-provider/unfinished-rounds/*`,
        belonging: ['configProvider'],
        innerComponent: <UnfinishedRoundsPage />,
    },
    {
        path: `/config-provider/unfinished-rounds/job-schedule`,
        belonging: ['configProvider'],
        innerComponent: <UnfinishedRoundJobs />,
    },
    {
        path: '*',
        belonging: ['configProvider', 'backOffice'],
        innerComponent: <PageNotFoundComponent />,
    },
];
